/**
 * Customer Portal Entry Point — بوابة العملاء
 */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CustomerAuthProvider, useCustomerAuth } from './context/CustomerAuthContext';
import { ToastProvider } from './context/ToastContext';
import { DialogProvider } from '../context/DialogContext';

import CustomerLayout    from './layouts/CustomerLayout';
import LoginPage         from './pages/auth/LoginPage';
import RegisterPage      from './pages/auth/RegisterPage';
import HomePage          from './pages/home/HomePage';
import OrdersPage        from './pages/orders/OrdersPage';
import NewOrderPage      from './pages/orders/NewOrderPage';
import OrderDetailPage   from './pages/orders/OrderDetailPage';
import OrderOffersPage  from './pages/orders/OrderOffersPage';
import AddressesPage     from './pages/addresses/AddressesPage';
import ProfilePage       from './pages/profile/ProfilePage';
import OrderChatPage     from './pages/chat/OrderChatPage';
import WalletPage             from './pages/wallet/WalletPage';
import PaymentCallbackPage   from './pages/wallet/PaymentCallbackPage';

const Guard = ({ children }) => {
  const { isAuthenticated, loading } = useCustomerAuth();
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: '#03111e',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: '1.5rem', fontFamily: "'Cairo', sans-serif", direction: 'rtl',
      }}>
        <img
          src="/assets/images/logo/white-logo.png"
          alt="وترلي"
          style={{ height: 56, objectFit: 'contain', opacity: 0.9 }}
        />
        <div style={{ position: 'relative', width: 48, height: 48 }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            border: '3px solid rgba(10,186,181,0.15)',
            borderTopColor: '#0ABAB5',
            animation: 'wt-guard-spin 0.8s linear infinite',
          }}/>
          <div style={{
            position: 'absolute', inset: 6,
            borderRadius: '50%',
            border: '2px solid rgba(10,186,181,0.08)',
            borderBottomColor: 'rgba(10,186,181,0.4)',
            animation: 'wt-guard-spin 1.4s linear infinite reverse',
          }}/>
        </div>
        <style>{`@keyframes wt-guard-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/customer/login" replace />;
};

const CustomerApp = () => (
  <CustomerAuthProvider>
    <ToastProvider>
      <DialogProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/customer/login"    element={<LoginPage />} />
          <Route path="/customer/register" element={<RegisterPage />} />

          {/* Protected */}
          <Route element={<Guard><CustomerLayout /></Guard>}>
            <Route path="/customer"              element={<Navigate to="/customer/home" replace />} />
            <Route path="/customer/home"         element={<HomePage />} />
            <Route path="/customer/orders"       element={<OrdersPage />} />
            <Route path="/customer/orders/new"   element={<NewOrderPage />} />
            <Route path="/customer/orders/:id"         element={<OrderDetailPage />} />
            <Route path="/customer/orders/:id/offers"  element={<OrderOffersPage />} />
            <Route path="/customer/addresses"      element={<AddressesPage />} />
            <Route path="/customer/profile"        element={<ProfilePage />} />
            <Route path="/customer/chat/:id"       element={<OrderChatPage />} />
            <Route path="/customer/wallet"                    element={<WalletPage />} />
            <Route path="/customer/payment/callback"          element={<PaymentCallbackPage />} />
          </Route>

          <Route path="/customer/*" element={<Navigate to="/customer/home" replace />} />
        </Routes>
      </BrowserRouter>
      </DialogProvider>
    </ToastProvider>
  </CustomerAuthProvider>
);

export default CustomerApp;
